import { useEffect, useState } from 'react'
import styled from 'styled-components'

import Api from 'services/api'

import { color } from 'styles/colors'

const UnreadSiteMessagesCount = () => {
  const [unreadCount, setUnreadCount] = useState(null)

  useEffect(() => {
    const poll = () => {
      Api.SiteMessagesUserRead.getUnread()
        .then((res) => {
          setUnreadCount(res.siteMessageIds.length)
        })
    }

    poll()

    const pollingInterval = setInterval(poll, 60 * 1000) // poll once a minute

    return () => clearInterval(pollingInterval)
  }, [])

  return (
    unreadCount > 0
      ? (
        <S.span data-testid="unreadSiteMessageCount">
          <div>{unreadCount}</div>
        </S.span>
      )
      : null
  )
}

export default UnreadSiteMessagesCount

const S = {
  span: styled.span`
    display: block;
    background: ${color('notificationDot')};
    color: ${color('navLinkText')};
    font-size: 9px;
    border-radius: 50%;
    width: 13px;
    height: 13px;
    margin-top: 5px;
    margin-left: -4px;
    text-align: center;
    line-height: 12px;
  `
}
